import { mapActions } from 'vuex';

// Працює в рамках кабінету - на інших роутах треба перевіряти
module.exports = {
  data() {
    return {
      mixinUserData: null,
    };
  },
  methods: {
    ...mapActions({
      mixinFetchUserData: 'Common/userData',
    }),
  },
  computed: {
    isTestUser() {
      const testUsers = [
        525321, 7885651, 8027647,
        10091832, 929064, 5596594,
        13193407, 9390315, 9072584,
        10432233, 12744151, 5551008,
        15729647,14113979
      ];

      return testUsers.includes(this.mixinUserData?.userId);
    },
  },
  async mounted() {
    const response = await this.mixinFetchUserData();
    if (response) this.mixinUserData = response;
  },
};
